import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/authority-order.ts
const spaceAuthorityOrderSchema = z$1.literal("default");
//#endregion
export { spaceAuthorityOrderSchema };

//# sourceMappingURL=authority-order.js.map